/**
 * Router
 */
import React, {Fragment, useContext} from 'react';
import {
  Switch,
  Route,
  withRouter,
  useLocation,
  Redirect,
} from 'react-router-dom';
import Wos from './without-sidemenu';
import Can from './components/Can';
import AuthContext from './authContext';
import {firstPageComponent} from './utils/FirsPageComponent';
// React
// Components

import Login from './pages/login';
import DriverManagement from './pages/driverManagement';
// Type
export type Routes = RouteInterface[];
export type RouteInterface = {
  component: Function;
  path: string;
  routes?: string;
};

// Const routes
export const routes: Routes = [
  {
    path: '/driver-management',
    component: DriverManagement,
    //wos
  },
  {
    path: '/login',
    component: Login,
    //wos
  },
];
const Referee = () => {
  return (
    <Fragment>
      <Switch>
        {checkAuth() && (
          <Redirect from="/login" to={firstPageComponent('DRIVER')} />
        )}
        <Route path="/" component={Wos} />
      </Switch>
    </Fragment>
  );
};

export default withRouter(Referee);
const checkAuth = () => localStorage.getItem('token') !== null;
// A special wrapper for <Route> that knows how to
// handle "sub"-routes by passing them in a `routes`
// prop to the component it renders.
export function RouteWithSubRoutes(route: RouteInterface) {
  const authContext = useContext(AuthContext);
  return (
    <Can
      role={authContext.user.role}
      perform={route.path}
      yes={() => (
        <Route
          exact
          path={route.path}
          render={props => {
            if (!checkAuth()) {
              window.location.reload();
              // eslint-disable-next-line react/prop-types
              props.history.push('/login');
            }
            return <route.component {...props} routes={route.routes} />;
          }}
        />
      )}
    />
  );
}
